import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix

/**
 * Class representing a filter view for user profiles.
 * @extends JetView
 */
export default class FilterUsuarioPerfilView extends JetView {
    /**
     * Configures the layout of the filter view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row', // CSS class for styling
                    cols: [
                        {
                            view: 'text', // Text input for User
                            name: 'User',
                            label: "<span class='icon-user'></span>" + _('Usuario'), // Label with icon
                            labelPosition: 'top',
                            placeholder: _('Usuario'), // Placeholder text
                            invalidMessage: _('Usuario is required'), // Validation message
                        },
                        {
                            view: 'text', // Text input for Profile
                            name: 'Profile',
                            label: _('Perfil'), // Label for Profile
                            labelPosition: 'top',
                            placeholder: _('Perfil'), // Placeholder text
                            invalidMessage: _('Perfil is required'), // Validation message
                        },
                        { id: 'grav2', gravity: 1 }, // Gravity element for layout
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container', // CSS class for styling
            height: screen == 'small' ? 121 : 0, // Conditional height based on screen size
            rows: [
                {
                    margin: 10,
                    cols: [left], // Including left section
                },
            ],
        };

        const buttons = {
            id: 'b2', // ID for button section
            rows: [
                {
                    margin: 10,
                    responsive: 'b2', // Responsive design identifier
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity element for layout
                        {
                            view: 'button', // Button for clearing the form
                            value: _('Limpiar'), // Button label
                            width: screen == 'small' ? 0 : 100, // Conditional width
                            minWidth: 200, // Minimum width
                            click: () => {
                                this.getRoot().clear(); // Clear form values on click
                            },
                        },
                        {
                            view: 'button', // Button for submitting the form
                            value: _('Consultar'), // Button label
                            type: 'form', // Button type
                            width: screen == 'small' ? 0 : 100, // Conditional width
                            minWidth: 200, // Minimum width
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('usuarioPerfil:filter', [filterdata]); // Trigger filter event
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form', // Main view type
            rows: [upper_section, buttons], // Including upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object passed to the init method.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                // Check for small screen width
                $$('grav').hide(); // Hide gravity element for small screens
                $$('grav2').hide(); // Hide second gravity element for small screens
            }
        });
    }
}

// FILE DOCUMENTED
